(function () {
  const initCollectionSlider = (section) => {
    const sliderWrapper = section.querySelector(
      ".collection-hero__slider-wrapper.swiper"
    );
    if (!sliderWrapper) return;

    const slides = sliderWrapper.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    new Swiper(sliderWrapper, {
      slidesPerView: 2,
      spaceBetween: 20,
      speed: 800,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 4,
        },
      },
    });
  };

  class CollectionCategorySelect extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector(".collection-category-select__trigger");
      this.modal = this.querySelector(".collection-category-select__modal");
      if (!this.trigger || !this.modal) return;

      this.inner = this.modal.querySelector(".collection-category-select__inner");
      this.overlay = this.modal.querySelector(".collection-category-select__overlay");
      this.closeButton = this.modal.querySelector(".collection-category-select__close");

      this.trigger.addEventListener("click", () => this.openModal());
      this.trigger.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          this.openModal();
        }
      });

      this.overlay?.addEventListener("click", () => this.closeModal());
      this.closeButton?.addEventListener("click", () => this.closeModal());

      this.onKeyDown = (e) => {
        if (e.key === "Escape" && this.modal.classList.contains("open")) {
          this.closeModal();
        }
      };
      document.addEventListener("keydown", this.onKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener("keydown", this.onKeyDown);
    }

    openModal() {
      this.modal.classList.add("open");
      this.trigger.setAttribute("aria-expanded", "true");
      document.body.classList.add("overflow-hidden");
      trapFocus(this.modal, this.inner);
    }

    closeModal() {
      this.modal.classList.remove("open");
      this.trigger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("overflow-hidden");
      removeTrapFocus(this.trigger);
    }
  }

  if (!customElements.get("collection-category-select")) {
    customElements.define("collection-category-select", CollectionCategorySelect);
  }

  const initSection = (section) => {
    initCollectionSlider(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();
